import apiService from '../utils/apiService';

import {
  ADD_MUNICIPALITY_TO_KJS,
  ADD_MUNICIPALITY_TO_KJS_START,
  ADD_MUNICIPALITY_TO_KJS_ERROR,
  UPDATE_MUNICIPALITY_WITH_KJS,
  UPDATE_MUNICIPALITY_WITH_KJS_START,
  UPDATE_MUNICIPALITY_WITH_KJS_ERROR,
  FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE,
  FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_START,
  FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_ERROR,
  FIND_ALL_KJS_WITH_MUNICIPALITY_FILTER_PAGEABLE,
  FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS,
  FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_START,
  FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_ERROR,
  CLEAR_KJS_WITH_MUNICIPALITY,
} from './types';

import {
  kjsMunicipalityAddPath,
  kjsMunicipalityUpdatePath,
  kjsMunicipalityFindByKjsIdPath,
  kjsMunicipalityFindAllPageablePath,
  filterPageablePath,
} from '../constants/apiEndpoints';

import {
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';

import { createNotification } from '../utils';

const clearKjsMunicipality = () => {
  return {
    type: CLEAR_KJS_WITH_MUNICIPALITY,
  };
};

const addKjsWithMunicpalityStart = () => {
  return {
    type: ADD_MUNICIPALITY_TO_KJS,
  };
};

const addKjsWithMunicpalitySuccessfully = (data) => {
  return {
    type: ADD_MUNICIPALITY_TO_KJS_START,
    payload: data,
  };
};

const addKjsWithMunicpalityUnsuccessfully = (err) => {
  return {
    type: ADD_MUNICIPALITY_TO_KJS_ERROR,
    payload: err,
  };
};

const updateKjsWithMunicpalityStart = () => {
  return {
    type: UPDATE_MUNICIPALITY_WITH_KJS_START,
  };
};

const updateKjsWithMunicpalitySuccessfully = (data) => {
  return {
    type: UPDATE_MUNICIPALITY_WITH_KJS,
    payload: data,
  };
};

const updateKjsWithMunicpalityUnsuccessfully = (err) => {
  return {
    type: UPDATE_MUNICIPALITY_WITH_KJS_ERROR,
    payload: err,
  };
};

const getKjsWithMunicpalityByKjsStart = () => {
  return {
    type: FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_START,
  };
};
const getKjsWithMunicpalityByKjsSuccessfully = (data) => {
  return {
    type: FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS,
    payload: data,
  };
};
const getKjsWithMunicpalityByKjsUnsuccessfully = (err) => {
  return {
    type: FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_ERROR,
    payload: err,
  };
};

const getKjsMunicipalityPageableStart = () => {
  return {
    type: FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_START,
  };
};

const getKjsMunicipalityPageableSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};

const getKjsMunicipalityFilterPageableSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: FIND_ALL_KJS_WITH_MUNICIPALITY_FILTER_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};

const getKjsMunicipalityPageableUnsuccessfully = (err) => {
  return {
    type: FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_ERROR,
    payload: err,
  };
};

export const createKjsWithMunicpality = (
  kjsWithMunicipality,
  callback,
  message
) => {
  return (dispatch) => {
    dispatch(addKjsWithMunicpalityStart());
    return apiService
      .post(kjsMunicipalityAddPath(), kjsWithMunicipality)
      .then((response) => {
        dispatch(addKjsWithMunicpalitySuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          message.kjs,
          message.successMunicipalityToKjs
        );
      })
      .catch((err) => {
        dispatch(addKjsWithMunicpalityUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          message.kjs,
          message.unsuccessMunicipalityToKjs
        );
      });
  };
};

export const updateKjsWithMunicpality = (
  kjsWithMunicipality,
  callback,
  message
) => {
  return (dispatch) => {
    dispatch(updateKjsWithMunicpalityStart());
    return apiService
      .post(kjsMunicipalityUpdatePath(), kjsWithMunicipality)
      .then((response) => {
        dispatch(updateKjsWithMunicpalitySuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          message.kjs,
          message.message
        );
      })
      .catch((err) => {
        dispatch(updateKjsWithMunicpalityUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          message.kjs,
          err?.response?.data?.message
        );
      });
  };
};

export const findKjsWithMunicpalityByKJSId = (kjsId) => {
  return (dispatch) => {
    dispatch(getKjsWithMunicpalityByKjsStart());
    return apiService
      .get(kjsMunicipalityFindByKjsIdPath(kjsId))
      .then((response) => {
        dispatch(getKjsWithMunicpalityByKjsSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getKjsWithMunicpalityByKjsUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllKjsMunicipalityPageable = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getKjsMunicipalityPageableStart());
    return apiService
      .get(kjsMunicipalityFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getKjsMunicipalityPageableSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getKjsMunicipalityPageableUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllKjsMunicipalityFilterPageable = (
  pageNumber,
  pageSize,
  data,
  succesCallback
) => {
  return (dispatch) => {
    dispatch(getKjsMunicipalityPageableStart());
    return apiService
      .post(filterPageablePath(pageNumber, pageSize), data)
      .then((response) => {
        dispatch(
          getKjsMunicipalityFilterPageableSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
        succesCallback();
      })
      .catch((err) => {
        dispatch(getKjsMunicipalityPageableUnsuccessfully(err?.response?.data));
      });
  };
};

export const clearKjsWithMunicipality = () => {
  return (dispatch) => {
    dispatch(clearKjsMunicipality);
  };
};
